<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">CONSULTA DE RECIBOS DE CADETES</h1>
        </section>

        <section>
            <mat-card class="mat-elevation-z0">
                <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="1rem">
                    <div fxFlex="30">
                        <mat-form-field appearance="outline">
                            <mat-label>Cadete</mat-label>
                            <mat-select>
                                <mat-option *ngFor="let option of options" [value]="option.value">
                                    {{option.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex="30">
                        <mat-form-field appearance="outline">
                            <mat-label>Desde</mat-label>
                            <input matInput [matDatepicker]="dateFrom" readonly>
                            <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                            <mat-datepicker #dateFrom>
                            </mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div fxFlex="30">
                        <mat-form-field appearance="outline">
                            <mat-label>Hasta</mat-label>
                            <input matInput [matDatepicker]="dateTo" readonly>
                            <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                            <mat-datepicker #dateTo>
                            </mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div fxFlex="10">
                        <button mat-flat-button class="squared-btn">Buscar</button>
                    </div>
                </div>

                <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" id="table">

                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef class="table-header">ID</th>
                        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef class="table-header">FECHA</th>
                        <td mat-cell *matCellDef="let element"> {{element.date}} </td>
                    </ng-container>

                    <ng-container matColumnDef="comprobante">
                        <th mat-header-cell *matHeaderCellDef class="table-header">COMPROBANTE</th>
                        <td mat-cell *matCellDef="let element"> {{element.comprobante}} </td>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL</th>
                        <td mat-cell *matCellDef="let element"> {{element.total}} </td>
                    </ng-container>

                    <ng-container matColumnDef="liquidado">
                        <th mat-header-cell *matHeaderCellDef class="table-header">LIQUIDADO</th>
                        <td mat-cell *matCellDef="let element"> {{element.liquidado}} </td>
                    </ng-container>

                    <ng-container matColumnDef="balance">
                        <th mat-header-cell *matHeaderCellDef class="table-header">SALDO</th>
                        <td mat-cell *matCellDef="let element"> {{element.balance}} </td>
                    </ng-container>

                    <ng-container matColumnDef="pdf">
                        <th mat-header-cell *matHeaderCellDef class="table-header">PDF</th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-flat-button class="squared-btn">Generar</button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </mat-card>
        </section>
    </div>
</div>